// eslint-disable-next-line require-jsdoc
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
// IDS Components
import Dropdown, { MenuItem } from '@ids-ts/dropdown';
import Button from '@ids/button';
import { useDispatch } from 'react-redux';
import { ReduxEvent, taxFormUnavailableMessage } from '../../../../assets/pagedata/constant';
import { addToCart } from '../../../services/productDataService';
import Loader from '../../Common/Loader';
import {
  isTaxFormUnavailable,
  getCurrentFisicalYear,
  taxFormsNextAvlDate,
  isProductOutOfStock,
  currencyFormatter,
} from '../../Util/CommonUtils';
// eslint-disable-next-line require-jsdoc
export const AddToCartPricingSection = (props) => {
  const { pageData, loading, error, pricing, outOfStockItems = [] } = props;
  const [selectedPrice, setSelectedPrice] = useState(
    pricing && pricing.length > 0 ? `${pricing[0].Sku}` : '',
  );
  const [addToCartClicked, setAddToCartClicked] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const [outOfStockSku, setOutOfStockSku] = useState({});
  const dispatch = useDispatch();


  useEffect(() => {
      if (pricing && pricing.length > 0) {
        const outOfStatusForSku = isProductOutOfStock(
          {
            pfid: null,
            sku: `${pricing[0].Sku}`,
          },
          outOfStockItems,
        );
        if(outOfStatusForSku) setOutOfStockSku(outOfStatusForSku);
      }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [outOfStockItems]);

  const formatDropDownMenu = (q) => {
    switch (pageData.Department.PriceDisplay) {
      case 'case':
        return `${q.Quantity} case - ${
          q.DiscPrice ? currencyFormatter(q.DiscPrice) : currencyFormatter(q.ListPrice)
        }`;

      case 'rolls':
        return `${q.Quantity} rolls - ${
          q.DiscPrice ? currencyFormatter(q.DiscPrice) : currencyFormatter(q.ListPrice)
        }`;

      case 'color':
        return `${q.Color} - ${
          q.DiscPrice ? currencyFormatter(q.DiscPrice) : currencyFormatter(q.ListPrice)
        }`;

      case 'printer':
        return `${q.PrinterType} - ${
          q.DiscPrice ? currencyFormatter(q.DiscPrice) : currencyFormatter(q.ListPrice)
        }`;

      case 'pack':
        return `${q.Quantity} (pack of 5) - ${
          q.DiscPrice ? currencyFormatter(q.DiscPrice) : currencyFormatter(q.ListPrice)
        }`;

      default:
        return `${q.Quantity} for ${
          q.DiscPrice ? currencyFormatter(q.DiscPrice) : currencyFormatter(q.ListPrice)
        }`;
    }
  };

  const getQuantityForSinglePrice = (q) => {
    switch (pageData.Department.PriceDisplay) {
      case 'case':
        return `${q.Quantity} case`;

      case 'rolls':
        return `${q.Quantity} rolls`;

      case 'color':
        return `${q.Color}`;

      case 'printer':
        return `${q.PrinterType}`;

      case 'pack':
        return `${q.Quantity} (pack of 5)`;

      default:
        return `${q.Quantity}`;
    }
  };

  const addToCartSuccess = (pageInfo) => {
    props.logToIMWebLogger(
      'info',
      `ProductPage -> AddToCartPricingSection: onAddToCartClicked success`,
    );
    dispatch({
      type: ReduxEvent.PAGE_DATA,
      data: {
        pageData: {
          cartCount: pageInfo.CartCount,
          login: pageInfo.login,
          promotionMessage: pageInfo.PromotionMessage,
        },
      },
    });
    setShowLoader(false);
    props.history.push('/cart');
  };

  const addToCartFailed = (err) => {
    props.logToIMWebLogger(
      'error',
      `ProductPage -> AddToCartPricingSection: onAddToCartClicked failed. Reason: ${err}`,
    );

    props.displayToast('Some error occured. Please try again.');
    setShowLoader(false);
  };

  const onAddToCartClicked = () => {
    setAddToCartClicked(true);

    if (!selectedPrice && pricing.length > 1) {
      return;
    }

    props.logToIMWebLogger(
      'info',
      `ProductPage -> AddToCartPricingSection: onAddToCartClicked called`,
    );

    setShowLoader(true);

    const params = {
      IsCustomizable: '0',
      PfId: pageData.Department.PFID,
      SKU: pricing.length > 1 ? selectedPrice : pricing[0].Sku,
    };

    addToCart(params, addToCartSuccess, addToCartFailed);
  };

  const getWarningText = () => {
    return addToCartClicked && !selectedPrice ? 'Please select a value.' : null;
  };

  const getPlaceHolder = () => {
    return loading ? 'Loading....' : error ? 'Error' : 'Select Value';
  };

  const getDropDownLabel = () => {
    switch (pageData.Department.PriceDisplay) {
      case 'color':
        return `Color and Price`;

      case 'printer':
        return `Printer and Price`;

      default:
        return `Quantity and Price`;
    }
  };

  const hasDiscount = (pr) => {
    return !!pr.DiscPrice;
  };

  const handleChange = (e) => {
    const sku = e.target.value;
    setSelectedPrice(sku);
      const skuOutOfStockSku = isProductOutOfStock(
        {
          pfid: null,
          sku,
        },
        outOfStockItems,
      );
      setOutOfStockSku(skuOutOfStockSku)
  };

  return (
    <div>
      {pricing.length === 1 && getDropDownLabel() === 'Quantity and Price' ? (
        <div className="margin-bottom-20">
          <div className="row">
            <div
              className={
                hasDiscount(pricing[0])
                  ? 'col-lg-4 col-sm-4 col-xs-4'
                  : 'col-lg-6 col-sm-6 col-xs-6'
              }
            >
              <p className="p2-regular font-wgt-500">Qty</p>
            </div>
            <div
              className={
                hasDiscount(pricing[0])
                  ? 'col-lg-4 col-sm-4 col-xs-4'
                  : 'col-lg-6 col-sm-6 col-xs-6'
              }
            >
              <p
                className="p2-regular font-wgt-500"
                style={hasDiscount(pricing[0]) ? { color: '#8d9096' } : {}}
              >
                List Price
              </p>
            </div>
            {hasDiscount(pricing[0]) && (
              <div className="col-lg-4 col-sm-4 col-xs-4">
                <p className="p2-regular font-wgt-500" style={{ color: 'rgb(44, 160, 28)' }}>
                  Your Price
                </p>
              </div>
            )}
          </div>
          <hr />

          <div className="row">
            <div
              className={
                hasDiscount(pricing[0])
                  ? 'col-lg-4 col-sm-4 col-xs-4'
                  : 'col-lg-6 col-sm-6 col-xs-6'
              }
            >
              <p className="p2-regular">{getQuantityForSinglePrice(pricing[0])}</p>
            </div>
            <div
              className={
                hasDiscount(pricing[0])
                  ? 'col-lg-4 col-sm-4 col-xs-4'
                  : 'col-lg-6 col-sm-6 col-xs-6'
              }
            >
              <p
                className="p2-regular"
                style={
                  hasDiscount(pricing[0])
                    ? { color: '#8d9096', textDecoration: 'line-through' }
                    : {}
                }
              >
                {currencyFormatter(pricing[0].ListPrice)}
              </p>
            </div>
            {hasDiscount(pricing[0]) && (
              <div className="col-lg-4 col-sm-4 col-xs-4">
                <p className="p2-regular font-wgt-500" style={{ color: 'rgb(44, 160, 28)' }}>
                  {currencyFormatter(pricing[0].DiscPrice)}
                </p>
              </div>
            )}
          </div>
        </div>
      ) : (
        <Dropdown
          label={getDropDownLabel()}
          theme="quickbooks"
          buttonType="secondaryGhost"
          onChange={(e) => handleChange(e)}
          value={selectedPrice}
          className="margin-bottom-20 dropdown-background-color-white-label"
          placeholder={getPlaceHolder()}
          errorText={error ? 'Unable to fetch the value.' : null}
          warningText={getWarningText()}
        >
          {pricing.map((q, key) => {
            return (
              <MenuItem key={`${key}`} value={`${q.Sku}`}>
                {formatDropDownMenu(q)}
              </MenuItem>
            );
          })}
        </Dropdown>
      )}

      {pageData.Department.checkTaxProductUnavailblity && isTaxFormUnavailable() ? (
        <span className="tax-form-unavailable-msg">{`${getCurrentFisicalYear()} ${taxFormUnavailableMessage} ${taxFormsNextAvlDate()}`}</span>
      ) : (
        <>
          {(outOfStockSku &&
              !outOfStockSku.displayOutOfStock) && (
            <Button
              theme="intuit"
              className="margin-bottom-20 pricing-btn"
              onClick={onAddToCartClicked}
              data-wa-link="Add to cart"
              data-ui-object="button"
              data-refer-ui-access-point={`add_to_cart| ${props.contentVariable.toLowerCase()}`}
            >
              Add to cart
            </Button>
          )}

          {(outOfStockSku &&
              outOfStockSku.displayOutOfStock) && (
            <div className="product-unavailable-msg margin-bottom-20">
              {outOfStockSku.outOfStockMessage}
            </div>
          )}

          {!pageData.Department.PricingInformation.HideShipInfo && (
            <p className="p2-regular bottom-statement">
              Orders typically ship within 48 hours. Custom orders may require up to six days. Rush
              orders available. Please call <span className="font-wgt-500">(866) 570-3842.</span>
            </p>
          )}
        </>
      )}
      <Loader show={showLoader} size={80} loadingText="Please wait.." />
    </div>
  );
};

AddToCartPricingSection.propTypes = {
  pageData: PropTypes.object.isRequired,
  loading: PropTypes.bool.isRequired,
  error: PropTypes.bool.isRequired,
  pricing: PropTypes.array.isRequired,
  logToIMWebLogger: PropTypes.func.isRequired,
};
